import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useMobileMode } from '../../hooks/useMobileMode.js';
import { LinkButton } from '../../ui-kit/LinkButton/LinkButton.js';
import { style } from '../../utils/style.js';
const BUTTON_STYLE = {
    default: 'bg-main-divider text-primary-main rounded hover:text-primary-main',
    transparent: 'backdrop-opacity-30 bg-white/30 hover:text-primary-hover text-white',
};
export const InternetBankButton = JSX(({ version, text, mobileText, ...rest }) => {
    const isMobileMode = useMobileMode();
    const buttonText = isMobileMode ? mobileText : text;
    return buttonText ? (_jsx(LinkButton, { className: style('py-s px-lg font-light whitespace-nowrap', BUTTON_STYLE[version === 'transparent' ? 'transparent' : 'default']), ...rest, children: buttonText })) : null;
});
//# sourceMappingURL=InternetBankButton.js.map